import React from 'react'
import { Link } from 'react-router-dom'
import appRoutes from '../routes/routeConfig'

const Page404 = () => {
      return (
        <div className="account-body accountbg">
            <div className="container">
                <div className="row vh-100 d-flex justify-content-center">
                    <div className="col-12 align-self-center">
                        <div className="row">
                            <div className="col-lg-5 mx-auto">
                                <div className="card">
                                    <div className="card-body p-0 auth-header-box">
                                        <div className="text-center p-3">
                                            <Link to={appRoutes.root} className="logo logo-admin mt-05">
                                                <img src="/assets/images/logo-sm.png" height="50" alt="logo" className="auth-logo" />
                                            </Link>
                                            <h4 className="mt-1 mb-1 font-weight-semibold text-white font-18">Oops! Sorry page not found</h4>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="ex-page-content text-center">
                                            <img src="/assets/images/error.svg" alt="0" className="" height="170" />
                                            <h1 className="mt-2 mb-2">404!</h1>  
                                            <h5 className="font-16 text-muted mb-2">This resource does not exist or has been moved</h5>                                    
                                        </div>          
                                        <Link className="btn btn-primary btn-block waves-effect waves-light" to={appRoutes.root}>Back Home <i className="fas fa-home ml-1"></i></Link>                         
                                    </div>
                                    <div className="card-body bg-light-alt text-center">
                                        <span className="text-muted d-none d-sm-inline-block">Central Bank of Nigeria &copy; {new Date().getFullYear()}</span>                                              
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Page404